import React from 'react'

const Form = (props) => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="form-input">
                <input className={typeof props.errors.password !== 'undefined' && props.errors.password.length > 0 ?"error":""} autoFocus={true} type="password" name="password" value={props.password} placeholder="New Password" onChange={props.onChange} />
            </div>
            <div className="form-input">
                <input className={typeof props.errors.password2 !== 'undefined' && props.errors.password2.length > 0 ?"error":""} type="password" name="password2" value={props.password2} placeholder="Confirm New Password" onChange={props.onChange} />
                <span className="error">{props.errors.password2}</span>
            </div>
            <div className="actions">
                <button>Save</button>
            </div>
        </form>
    )
}

export default Form